export default function generateBreadcrumbId(url: string) {
    const removedFirstSlash = url.replace('/', '');
    return `${removedFirstSlash.replace(/\//g, '-')}-crumb`;
}
